import * as React from 'react';

import {SVGIcon} from '@homeaway/react-svg';
import {CHECK__16} from '@homeaway/svg-defs';

export class FlagsMenu extends React.Component {
    render() {
        return (
            <div className="site-header-tray__menu site-header-tray__drawer">
                <div className="site-header-tray__menu-items">
                    {this.props.flags.items.map((item, i) => (
                        <a className={`site-header-tray__menu-item-link site-header-tray__menu-item-link--icon-right site-header-tray__menu-item-link--flag ${item.countryCode}`} data-bypass="true" href={item.link} key={`${item.countryCode}-${item.link}`}>
                            <span>
                                <i aria-hidden="true" className={`site-header-tray__menu-item-icon flag-${item.countryCode}`} />
                                <span className="site-header-tray__menu-item-text">{item.text}</span>
                            </span>
                            {i === 0 &&
                                <SVGIcon className="text-brand" inline markup={CHECK__16} />
                            }
                        </a>
                    ))}
                </div>
            </div>
        );
    }
}
